import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'

import Teamhero from '../components/Team/Teamhero'
import Ourteam from '../components/Team/Ourteam'

import Program from '../components/Team/Program'
import Footerhero from '../components/Footer/Footerhero'

const Teampage = () => {
    return (
        <div>
        <Navbar/>
        <Teamhero/>
   
        <Ourteam/>
    
        <Program/>
        <Footerhero/>
  



        <Footer/>

        </div>
    )
}

export default Teampage